import { BsExclamationTriangle, BsX } from "react-icons/bs";

/**
 * What an edit did to customs flags beyond the parcel in front of the operator.
 *
 * The rule is computed over the whole (user, flight) group, so moving a parcel
 * or changing its value can flip the flag on its SIBLINGS. That happens
 * silently otherwise: the operator edits one parcel and five others change
 * colour on a page they are not looking at.
 */
const LABELS = {
  0: "არ საჭიროებს განბაჟებას",
  1: "წითელი — უნდა განბაჟდეს",
  2: "მწვანე — განბაჟებულია",
  3: "ყვითელი — საბაჟოზეა",
};

const DOT = {
  0: "bg-slate-300",
  1: "bg-red-500",
  2: "bg-green-500",
  3: "bg-yellow-400",
};

const BorderChangeNotice = ({ reports, onClose }) => {
  if (!reports?.length) return null;

  const total = reports.reduce((a, r) => a + (r.changed?.length || 0), 0);
  if (!total) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[1200] flex items-center justify-center p-3"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-3">
          <h2 className="font-bold text-lg dark:text-white flex items-center gap-2">
            <BsExclamationTriangle className="text-amber-500" />
            განბაჟების სტატუსი შეიცვალა ({total})
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-red-500">
            <BsX className="text-2xl" />
          </button>
        </div>

        <p className="text-xs text-slate-500 dark:text-slate-300 mb-4">
          განბაჟება ჯგუფზე ითვლება (მომხმარებელი + რეისი), ამიტომ ამ ცვლილებამ
          სხვა ამანათებსაც შეუცვალა სტატუსი.
        </p>

        {reports.map((r, i) => (
          <div
            key={i}
            className="border border-slate-200 dark:border-slate-600 rounded-lg p-3 mb-3"
          >
            <p className="text-sm font-bold dark:text-white mb-1">
              იუზერი #{r.user_id} · {r.shipment_code}
            </p>
            <p className="text-xs text-slate-500 mb-2">
              ჯგუფი: {r.count} ამანათი · {r.sum_price} ₾ · {r.sum_weight} კგ →{" "}
              <b className={r.needs ? "text-red-600" : "text-green-600"}>
                {r.needs ? "საჭიროებს განბაჟებას" : "არ საჭიროებს განბაჟებას"}
              </b>
              <span className="text-slate-400">
                {" "}
                (ზღვარი: 300 ₾ / 30 კგ)
              </span>
            </p>

            <div className="flex flex-col gap-1">
              {r.changed.map((c) => (
                <div key={c.id} className="text-xs flex items-center gap-2 dark:text-slate-200">
                  <span className={`w-2 h-2 rounded-full shrink-0 ${DOT[c.from]}`} />
                  <span className="font-mono flex-1 truncate">{c.tracking_number}</span>
                  <span className="text-slate-400">{LABELS[c.from]}</span>
                  <span>→</span>
                  <span className={`w-2 h-2 rounded-full shrink-0 ${DOT[c.to]}`} />
                  <b>{LABELS[c.to]}</b>
                </div>
              ))}
            </div>

            {r.skipped_manual?.length > 0 && (
              <p className="text-[11px] text-slate-400 mt-2">
                ხელით დაყენებული, ხელუხლებელი: {r.skipped_manual.join(", ")}
              </p>
            )}
          </div>
        ))}

        <button
          onClick={onClose}
          className="rounded-md bg-teal_600 text-white text-sm font-bold px-6 h-10"
        >
          გასაგებია
        </button>
      </div>
    </div>
  );
};

export default BorderChangeNotice;
